import PropTypes from 'prop-types';
import React from 'react';
import { Card } from 'react-bootstrap';

import './styles.css';

const SurveyInformationSection = ({ sectionName, sectionCode, onEditModeClick}) => {
  return (
    <Card className="survey-info-card cursor-pointer" onClick={() => onEditModeClick(null, 'sections', true)}>
      <Card.Body>
        <div>
          <h4 className="mb-2">Section Name</h4>
          <span>{sectionName}</span>
        </div>
        <div className='pt-3'>
          <h4 className="mb-2">Section Code</h4>
          <span>{sectionCode}</span>
        </div>
      </Card.Body>
    </Card>
  );
};

SurveyInformationSection.propTypes = {
  sectionName: PropTypes.string.isRequired,
  onEditModeClick: PropTypes.func.isRequired,
};

SurveyInformationSection.defaultProps = {};

export default SurveyInformationSection;
